import { useTranslation } from 'i18n';
import { Box } from 'ui';

import { getNameInitials } from '../../../name';

export const SpeechBubbleAvatar = ({ fullName, onClick }: { fullName: string; onClick: () => void }) => {
  const { t } = useTranslation('features');

  return (
    <Box
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={t('annotations.speechBubbleAvatar.viewCommentAriaLabel', { values: { fullName } })}
      sx={{
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: '50%',
        display: 'flex',
        height: 40,
        justifyContent: 'center',
        width: 40,
      }}
    >
      <Box
        sx={({ palette }) => ({
          '&::after': {
            background: `radial-gradient(circle at top left, transparent 20px, white 20px)`,
            bottom: '-2px',
            boxSizing: 'border-box',
            content: '""',
            height: '20px',
            left: '-2px',
            position: 'absolute',
            transform: 'rotate(90deg)',
            width: '20px',
            zIndex: -1,
          },
          alignItems: 'center',
          backgroundColor: palette.neutral[40],
          borderRadius: '50%',
          color: 'white',
          cursor: 'pointer',
          display: 'flex',
          fontSize: '14px',
          fontWeight: 600,
          height: 36,
          justifyContent: 'center',
          position: 'relative',
          width: 36,
          zIndex: 2,
        })}
      >
        {getNameInitials(fullName)}
      </Box>
    </Box>
  );
};
